import React, { Component } from 'react'

import apis from '../api/api'

import { withTranslation } from 'react-i18next';

import Oeuvre from './Oeuvre'

class ListeOeuvres extends Component {

    constructor(props) {
        super(props)
        this.state = {
            fiches: [],
            searched_fiches: [],
            isLoading: false,
            isSearching: false,
            limit_style: {
                size: 0,
                minwidth: 100,
                minpadding: 1.5
            },
            all_keywords: null
        }
    }

    componentDidUpdate = async (prevProps) => {
        const { searched_keyword } = this.props
        if (prevProps.searched_keyword !== searched_keyword) {
            if (searched_keyword !== null) {
                let id = searched_keyword._id
                await apis.getFichesByKey(id)
                    .then((fiches) => {
                        this.setState({ searched_fiches: fiches.data.data })
                    })
                    .catch((e) => this.setState({ searched_fiches: [] }))
            }
            else {
                this.setState({ searched_fiches: [] })
            }
            this.prepareFiches(this.state.fiches)
        }
    }
    componentDidMount = async () => {
        this.setState({ isLoading: true })

        await apis.getAllFiches().then(fiches => {

            this.prepareFiches(fiches.data.data)
            this.setState({ isLoading: false })
        })
        await apis.getAllKeywordsWithKeys().then(items => {
            items = items.data.data
            this.setState({
                all_keywords: items,
            })
        })

    }
    itemInArray = (item) => {
        let existe = false
        this.state.searched_fiches.forEach(element => {
            if (element._id === item._id) {
                existe = true
            }
        });
        return existe
    }
    prepareFiches(fiches) {

        //Check if Searching or not
        let isSearching = this.props.searched_keyword !== null

        //Check if Oeuvre is Searched

        let size = fiches.length
        let limit_style =
        {
            size: size,
            minwidth: 100 - ((size - 1) * 3),
            minpadding: 1.5 - (size / 10)
        }
        for (let index = 0; index < size; index++) {
            let element = fiches[index]
            element.index = index
            element.isSearched = false
            if (isSearching && this.itemInArray(element)) {

                element.isSearched = true
            }

            fiches[index] = element;
        }
        this.setState({ fiches: fiches, limit_style: limit_style, isSearching: isSearching })


    }

    render() {
        const { fiches, isSearching, all_keywords, limit_style } = this.state
        const { t, isGrille } = this.props;

        if (typeof fiches !== 'undefined' && fiches.length > 0) {
            return (
                <section className={isGrille ? "oeuvres oeuvres-grille" : 'oeuvres oeuvres-search'}>
                    {
                        fiches.map(oeuvre => {
                            return <Oeuvre key={oeuvre._id} all_keywords={all_keywords} infos={oeuvre} index={oeuvre.index} isGrille={isGrille} isSearched={oeuvre.isSearched} isSearching={isSearching} limits={limit_style} setInfosFiche={this.props.setInfosFiche} />
                        })
                    }
                </section>
            )
        }
        else if (this.state.isLoading) {
            return (
                <section className='loading'>
                    {t('site.loading')}
                </section>
            )
        }
        else {
            return null
        }
    }
}

export default withTranslation()(ListeOeuvres)